export const GRADE_MODEL = "grade";

const gradeModel = {
  name: "",
  status: ""
};

export default gradeModel;
